"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichEditUnit = exports.create = exports.createOptions = void 0;
var tslib_1 = require("tslib");
var unit_converter_1 = require("../../base-utils/unit-converter");
Object.defineProperty(exports, "RichEditUnit", { enumerable: true, get: function () { return unit_converter_1.RichEditUnit; } });
var menu_1 = require("./context-menu/menu");
var creator_1 = require("./ribbon/creator");
var rich_edit_1 = require("./rich-edit");
tslib_1.__exportStar(require("./ribbon/index"), exports);
function createOptions() {
    var options = {
        ribbon: creator_1.createRibbon(),
        events: {},
        pdf: {},
        search: {},
        printing: {
            closePrintDialogWithHtmlPreview: true
        },
        fields: {},
        confirmOnLosingChanges: {},
        mailMerge: {},
        fonts: {
            fonts: [],
            mappings: {
                rules: []
            }
        },
        autoCorrect: {
            replaceInfoCollection: []
        },
        bookmarks: {
            visibility: false
        },
        contextMenu: new menu_1.SimpleContextMenu(),
        authentication: {},
        rangePermissions: {
            highlightRanges: true,
            showBrackets: true,
        },
        view: {
            simpleViewSettings: {
                paddings: {
                    left: 15,
                    right: 15,
                    top: 15,
                    bottom: 15,
                }
            },
            printLayoutViewSettings: {
                showHorizontalRuler: true
            }
        },
        spellCheck: {
            enabled: false,
        },
        document: {}
    };
    return options;
}
exports.createOptions = createOptions;
function create(htmlElement, options) {
    return new rich_edit_1.RichEdit(htmlElement, options);
}
exports.create = create;
